import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { configureStore} from '@reduxjs/toolkit'
import { Provider } from "react-redux";
import rootReducer from "./reducers/RootReducer";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas/RootSaga";

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), sagaMiddleware]
})
const root = ReactDOM.createRoot(document.getElementById('root'));

sagaMiddleware.run(rootSaga);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
